var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"testReport_pages3"},[_c('div',{staticClass:"title_borderground"},[_c('div',{staticClass:"title_borderground_content1"},[_vm._v(_vm._s(_vm.PagesInitData))]),_c('div',{staticClass:"title_borderground_content2"},[_vm._v("精准分析报告")]),_c('div',{staticClass:"title_borderground_content3"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }